'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
    this.newUser = {};
  }

  save() {
    this.$http.post(`/api/betaUsers`, this.newUser).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betausers/add/add.controller.js